import _ from 'lodash';
import { TransformedStudentDetail, User, CourseInfo } from '../types/userType';
import { Status } from '../enums';

export function transformStudentDetailData(data: {
  data: User[];
}): TransformedStudentDetail {
  const student = data.data[0]; // Assuming data.data always contains at least one student

  const father =
    student.parents?.find(
      (parent: User) => parent.family?.relation === 'FATHER'
    ) || ({} as User);
  const mother =
    student.parents?.find(
      (parent: User) => parent.family?.relation === 'MOTHER'
    ) || ({} as User);

  const currentDate = new Date();

  const currentAcademicYearCourseInfo: CourseInfo | undefined =
    student.courseInfo?.find((course: CourseInfo) => {
      return (
        currentDate >= new Date(course.academicYear.from) &&
        currentDate <= new Date(course.academicYear.to)
      );
    });

  const studentClass = !_.isEmpty(currentAcademicYearCourseInfo?.division)
    ? `${currentAcademicYearCourseInfo?.grade} ${currentAcademicYearCourseInfo?.division}`
    : currentAcademicYearCourseInfo?.grade;

  const passportExpiryDate = student?.officialDetails?.passportExpiryDate
    ? new Date(student.officialDetails?.passportExpiryDate).toDateString()
    : undefined;

  const customFieldsMap: Record<string, any> = {};
  student?.customFields?.forEach((customField: any) => {
    customFieldsMap[customField.name] = customField.value;
  });

  const siblingDetails: any[] = [];
  student?.siblings?.forEach((sibling: User) => {
    const currentSiblingCourseInfo = sibling.courseInfo?.find(
      (course: CourseInfo) => {
        return (
          currentDate >= new Date(course.academicYear.from) &&
          currentDate <= new Date(course.academicYear.to)
        );
      }
    );

    const siblingClass = currentSiblingCourseInfo?.division
      ? `${currentSiblingCourseInfo.grade} ${currentSiblingCourseInfo.division}`
      : currentSiblingCourseInfo?.grade || Status.INACTIVE;

    siblingDetails.push({
      status: sibling?.status,
      enrollmentNo: sibling?.enrollmentNo,
      name: sibling.name,
      class: siblingClass
    });
  });

  const academicYear = !_.isEmpty(currentAcademicYearCourseInfo)
    ? new Date(currentAcademicYearCourseInfo!.academicYear.from).getFullYear() +
      '-' +
      new Date(currentAcademicYearCourseInfo!.academicYear.to).getFullYear()
    : ' - ';

  const isNewAdmission =
    !_.isEmpty(student.rollOverInfo) &&
    student.rollOverInfo!.length === 1 &&
    student.rollOverInfo![0].isNewAdmission === true;

  return {
    studentDetails: {
      ...student,
      currentClass: studentClass || '',
      passportExpiryDate,
      customFieldsMap,
      currentCourseInfo: currentAcademicYearCourseInfo,
      academicYear,
      isNewAdmission
    },
    fatherDetails: father,
    motherDetails: mother,
    siblingDetails
  };
}
